import React from 'react';

var TestNoHook = function TestNoHook(_ref) {
  var stuff = _ref.stuff;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, JSON.stringify(stuff)));
};

TestNoHook.displayName = "TestNoHook";
export default TestNoHook;